module.exports = __webpack_public_path__ + "static/media/placeholder_8.cd5457d4.jpg";